import serviceUrls from 'src/constants/serviceUrls';
import axiosRequest from 'src/helpers/axiosRequest';

export const fetchDropdownOptions = (parentEntityName, parentEntityId, childEntityName) => {
  return axiosRequest('get', serviceUrls.CONTENTPARSER_GET_DROPDOWN_OPTS, { parentEntityName, parentEntityId, childEntityName });
};

export const fetchTypeSubTypeDropdownOptions = (countryId, typeId) => {
  if (typeId) {
    return axiosRequest('get', serviceUrls.CONTENTPARSER_GET_TYPESUBTYPE_DROPDOWN_OPTS, { countryId, typeId });
  } else return axiosRequest('get', serviceUrls.CONTENTPARSER_GET_TYPESUBTYPE_DROPDOWN_OPTS, { countryId });
};
